var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_600, BLACK_700, BLACK_900, getTestId, InfoTag, Typography, useBreakpoint } from '@airtel/air-design-system';
import { View, Image } from 'react-native';
import { getPackAmountWidgetStyles } from './PackAmountWidgetStyles';
export var PackAmountWidgetComponent = props => {
  var _props$planName = props.planName,
    planName = _props$planName === void 0 ? '' : _props$planName,
    _props$amount = props.amount,
    amount = _props$amount === void 0 ? '' : _props$amount,
    multiTextAmount = props.multiTextAmount,
    _props$oldAmount = props.oldAmount,
    oldAmount = _props$oldAmount === void 0 ? '' : _props$oldAmount,
    _props$subText = props.subText,
    subText = _props$subText === void 0 ? '' : _props$subText,
    _props$infoTagText = props.infoTagText,
    infoTagText = _props$infoTagText === void 0 ? '' : _props$infoTagText,
    infoTagProps = props.infoTagProps,
    _props$amountAccessib = props.amountAccessibilityProps,
    amountAccessibilityProps = _props$amountAccessib === void 0 ? {} : _props$amountAccessib,
    _props$oldAmountAcces = props.oldAmountAccessibilityProps,
    oldAmountAccessibilityProps = _props$oldAmountAcces === void 0 ? {} : _props$oldAmountAcces,
    _props$subTextAccessi = props.subTextAccessibilityProps,
    subTextAccessibilityProps = _props$subTextAccessi === void 0 ? {} : _props$subTextAccessi,
    style = props.style,
    _props$planNameAccess = props.planNameAccessibilityProps,
    planNameAccessibilityProps = _props$planNameAccess === void 0 ? {} : _props$planNameAccess,
    imageUrl = props.imageUrl,
    restProps = __rest(props, ["planName", "amount", "multiTextAmount", "oldAmount", "subText", "infoTagText", "infoTagProps", "amountAccessibilityProps", "oldAmountAccessibilityProps", "subTextAccessibilityProps", "style", "planNameAccessibilityProps", "imageUrl"]);
  var _props$withRoundImage = props.withRoundImage,
    withRoundImage = _props$withRoundImage === void 0 ? false : _props$withRoundImage;
  var testID = restProps.testID;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var packAmountWidgetStyles = getPackAmountWidgetStyles(props, isSmallScreen);
  var getPackAmountTitle = () => {
    var data = [Object.assign({
      text: "" + amount + (oldAmount && ' '),
      type: isSmallScreen ? 'h6-bold' : 'h5-bold',
      color: BLACK_900
    }, amountAccessibilityProps)];
    if (oldAmount) {
      data.push(Object.assign({
        text: oldAmount,
        type: isSmallScreen ? 'body-para-lg' : 'body-para-xl',
        color: BLACK_600,
        style: packAmountWidgetStyles.strikedText
      }, oldAmountAccessibilityProps));
    }
    return data;
  };
  return _jsxs(View, Object.assign({
    style: [packAmountWidgetStyles.container, style]
  }, restProps, {
    children: [_jsxs(View, Object.assign({
      style: [packAmountWidgetStyles === null || packAmountWidgetStyles === void 0 ? void 0 : packAmountWidgetStyles.imageContainer]
    }, {
      children: [!!imageUrl && _jsx(Image, Object.assign({
        source: {
          uri: imageUrl
        },
        resizeMode: withRoundImage ? 'cover' : 'contain',
        style: packAmountWidgetStyles === null || packAmountWidgetStyles === void 0 ? void 0 : packAmountWidgetStyles.imageStyle
      }, getTestId(testID, 'imageUrl'))), !!planName && _jsx(Typography, Object.assign({
        text: planName,
        type: !isSmallScreen ? 'h5' : 'h6',
        color: BLACK_900,
        style: packAmountWidgetStyles.planName
      }, getTestId(testID, 'planName'), planNameAccessibilityProps))]
    })), (multiTextAmount === null || multiTextAmount === void 0 ? void 0 : multiTextAmount.length) > 0 && _jsx(Typography, Object.assign({
      multiText: multiTextAmount
    }, getTestId(testID, 'multiTextAmount'))), (!!amount || !!oldAmount) && _jsx(Typography, Object.assign({
      multiText: getPackAmountTitle()
    }, getTestId(testID, 'planPrice'))), !!subText && _jsx(Typography, Object.assign({
      text: subText,
      type: isSmallScreen ? 'body-para-md' : 'body-para-lg',
      color: BLACK_700
    }, getTestId(testID, 'planSubText'), subTextAccessibilityProps)), _jsx(InfoTag, Object.assign({
      text: infoTagText,
      subType: "offer",
      iconName: "OfferButtonIcon",
      size: "lg"
    }, infoTagProps, {
      style: [packAmountWidgetStyles.infoTag, infoTagProps === null || infoTagProps === void 0 ? void 0 : infoTagProps.style]
    }, getTestId(testID, 'planInfoTag')))]
  }));
};
PackAmountWidgetComponent.genericRendererKey = 'AirPackAmountWidget';